import { useState } from "react";
import Logo from "../img/Logo_signcast_big-1080x322.png";
import { Link, useNavigate } from "react-router-dom";
import useAuthStore from "../store/authStore";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const { requestPasswordReset, isLoading, error, clearError } = useAuthStore();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    clearError(); // Clear any previous errors
    
    // Basic validation
    if (!email) {
      return;
    }
    
    const success = await requestPasswordReset(email);
    
    // Navigate to verification page if request is successful
    if (success) {
      navigate('/verify-reset');
    }
  };

  return (
    <div className="login-container bg-blue-50 w-full h-screen flex justify-center items-center">
      <div className="bg-white w-[420px] h-[440px] rounded-lg shadow-lg">
        <div className="flex flex-row justify-center pt-10">
          <img className="w-52 h-auto" src={Logo} alt="Logo" />
        </div>
        
        <div className="text-center mt-4 mb-2">
          <h2 className="text-xl font-semibold">Reset Your Password</h2>
          <p className="text-gray-600 text-sm px-10 py-2">
            Enter your email address and we'll send you a code to reset your password.
          </p>
        </div>
        
        <form onSubmit={handleSubmit}>
          {error && (
            <p className="text-red-500 text-[12px] text-center mt-2">{error}</p>
          )}
          
          <div className="flex flex-col pl-10">
            <p className="text-black text-[14px] pt-4 pb-2">
              Enter your email address
            </p>
            <input
              className="text-[14px] pl-4 w-[340px] h-[45px] rounded-lg border-2 border-gray-300"
              type="email"
              placeholder="Email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <p className="text-gray-500 text-[14px] pt-2">
              <Link 
                to="/login"
                style={{ textDecoration: 'none' }}
              >
                Back to Login
              </Link>
            </p>
          </div>
          
          <div className="flex flex-col pt-6 p-10 rounded-lg">
            <button
              type="submit"
              disabled={isLoading}
              className="h-[41px] w-full bg-blue-500 text-white text-[14px] font-bold rounded-lg hover:bg-blue-600 transition-colors"
            >
              {isLoading ? "Sending..." : "Send Reset Code"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword; 